var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.computedDivClass},[_c('v-col',{staticClass:"text-center align-center align-content-center",attrs:{"cols":"12"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }